import { render, staticRenderFns } from "./main.vue?vue&type=template&id=5972a016&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5972a016')) {
      api.createRecord('5972a016', component.options)
    } else {
      api.reload('5972a016', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=5972a016&", function () {
      api.rerender('5972a016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/alert/main.vue"
export default component.exports